import { Typography, Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Content from '../components/Layout/Content';
import ReusableTable from '../components/ReusableTable/ReusableTable';
import FilterDropDown from '../components/filterDropDown/FilterDropDown';
import SearchBar from '../components/SearchBar/Search';
import PaginationComponent from '../components/paginationComponent/ServerSidePaginationComponent';
import {
  handleTimeFilter,
  searchDataByKey,
  handleTypeFilter,
  documentsArrayConvertor,
} from '../shared/helper';
import {
  alltypesdocuments,
  NUMBER_OF_ROWS_PER_PAGE,
} from '../shared/constants';
import { BreadcrumbComponent } from '../components/BreadcrumbComponent/BreadcrumbComponent';
import { useLazyQuery } from '@apollo/client';
import { FETCH_ALL_DOCUMENTS_QUERY } from '../services/DocumentsQueries/DocumentsServices';
import { useSnackbar } from 'notistack';
import NotFound from '../components/NotFound/NotFoundPage';
import { SimpleBackdrop } from '../components/SimpleBackdropComponent/SimpleBackdrop';
import {
  DOCUMENTS,
  DOCUMENTS_TABLE_HEADING as tableHeading,
  DOCUMENTS_BREADCRUMBDATA as breadcrumbData,
} from '../shared/Strings';

const boxContainer = {
  position: 'relative',
  display: 'flex',
  flexWrap: 'wrap',
  top: 40,
  flex: 1,
};

const table = {
  marginTop: 8,
  '& .css-1kn3lhz': {},
};

export const Documents = props => {
  const [searchValue, setSearchValue] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [recordsData, setRecordedData] = useState([]);
  const [timeFilter] = useState('all');
  const [typeFilter, setTypeFilter] = useState('all');
  const [totalCount, setTotalCount] = useState();
  const [offset, setOffset] = useState(0);
  const { enqueueSnackbar } = useSnackbar();

  const [snackbar, setSnackbar] = useState(false);

  useEffect(() => {
    if (snackbar) {
      setSnackbar(false);
    }
  }, [snackbar, enqueueSnackbar]);

  const onSearch = text => {
    setSearchValue(text);
  };

  const [fetchAllDocuments, fetchAllDocumentsCall] = useLazyQuery(
    FETCH_ALL_DOCUMENTS_QUERY,
    {
      fetchPolicy: 'cache-and-network',
      onError: err => {
        enqueueSnackbar(DOCUMENTS.ON_ERROR_TEXT.WENT_WRONG_TEXT, {
          variant: 'error',
        });
      },
      onCompleted: res => {
        let parsed = JSON.parse(
          res.fetchAllDocumentReferences.documentReferenceList
        );
        let data = documentsArrayConvertor(parsed);
        setFilteredData(data);
        setRecordedData(data);
        setTotalCount(res.fetchAllDocumentReferences.count);
      },
    }
  );

  useEffect(() => {
    fetchAllDocuments({
      variables: {
        sourceUrl: '',
        count: NUMBER_OF_ROWS_PER_PAGE.toString(),
        offset: offset,
        dateFilter: 0,
        statusFilter: typeFilter === 'all' ? '' : typeFilter,
        searchFilter: searchValue,
      },
    });
  }, [offset, typeFilter, searchValue]);

  const onPageClick = pageNumber => {
    setOffset((pageNumber - 1) * 10);
  };

  const typeFilterOptions = {
    options: alltypesdocuments,
    value: typeFilter,
    changeHandler: ev => {
      setTypeFilter(ev.target.value);
    },
  };

  // React.useEffect(() => {
  //   const timeFilteredData = handleTimeFilter(
  //     timeFilter,
  //     recordsData,
  //     'recordedOn'
  //   );

  //   const typeFilteredData = handleTypeFilter(
  //     typeFilter,
  //     timeFilteredData,
  //     alltypesdocuments
  //   );
  //   const searchData = searchDataByKey(
  //     typeFilteredData,
  //     'documentName',
  //     searchValue
  //   );
  //   setFilteredData(searchData);
  // }, [timeFilter, searchValue, typeFilter, recordsData]);
  return (
    <Content>
      <BreadcrumbComponent
        breadcrumbData={breadcrumbData}></BreadcrumbComponent>
      <Typography variant="title">{DOCUMENTS.TITLE_TEXT}</Typography>
      <Box sx={boxContainer}>
        <SearchBar
          sx={{
            width: '50%',
            minWidth: '250px',
            maxWidth: '500px',
            marginTop: '8px',
          }}
          onSearch={onSearch}
          placeholder={DOCUMENTS.SEARCH_PLACEHOLDER_TEXT}
          setOffset={setOffset}
        />
        <FilterDropDown
          {...typeFilterOptions}
          //sx={dropdownBox}
          filterType="Type:"
        />
      </Box>
      <Box sx={table}>
        {!fetchAllDocumentsCall.loading && !filteredData.length ? (
          <NotFound title={DOCUMENTS.TITLE_TEXT} />
        ) : (
          <>
            <ReusableTable
              tableHeading={tableHeading}
              data={filteredData}
              setSnackbar={setSnackbar}
            />
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                marginTop: 18,
              }}>
              {totalCount > NUMBER_OF_ROWS_PER_PAGE && (
                <PaginationComponent
                  numberOfRowsPerPage={NUMBER_OF_ROWS_PER_PAGE}
                  count={totalCount}
                  onPageClick={onPageClick}
                  page={offset / 10}
                />
              )}
            </div>
          </>
        )}
      </Box>
      <SimpleBackdrop open={fetchAllDocumentsCall.loading} />
    </Content>
  );
};
